/** Returns the value, or an empty string when it is null or undefined. */
export function orEmpty<T>(value: T | null | undefined): T | '' {
  return value ?? '';
}

/** Same as `value || ''`. */
export function orBlank<T>(value: T): NonNullable<T> | '' {
  return (value || '') as NonNullable<T> | '';
}

/** Same as `value || null`. */
export function orNull<T>(value: T): NonNullable<T> | null {
  return value || null;
}

/** Same as `value || 0`. */
export function orZero<T>(value: T): NonNullable<T> | 0 {
  return (value || 0) as NonNullable<T> | 0;
}

/** Same as `a ?? b ?? ... ?? null`: the first value that is neither null nor undefined, otherwise null. */
export function firstNonNullish(...values: any[]): any {
  for (const value of values) {
    if (value !== null && value !== undefined) return value;
  }
  return null;
}

/** Same as `value ? Number(value) : 0`. */
export function numberOrZero(value: any): number {
  return value ? Number(value) : 0;
}

/** Same as `value || fallback`. */
export function orDefault<T, D>(value: T, fallback: D): NonNullable<T> | D {
  return value || fallback;
}
